export default "__VITE_ASSET__cbdb923f__"